import { render, staticRenderFns } from "./xueyang.vue?vue&type=template&id=7cc11664&scoped=true"
import script from "./xueyang.vue?vue&type=script&lang=ts"
export * from "./xueyang.vue?vue&type=script&lang=ts"
import style0 from "./xueyang.vue?vue&type=style&index=0&id=7cc11664&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc11664",
  null
  
)

export default component.exports